'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SwellRewardsMVMTInsider = {};
var customerDetails = {};
var activeCampaigns = void 0;

var newsletterBindingExists = false;
var $dom = {};

var cacheDom = function cacheDom() {
  $dom.pointsBalance = $('[swell-rewards-points-count]');
  $dom.insiderCardYoutube = $('[data-campaign-id="youtube-follow"]');
  $dom.insiderCardNewsletter = $('[data-campaign-id="join-newsletter"]');
  $dom.insiderLandingCTA = $('#login-to-insider');
};

var getCustomerDetails = function getCustomerDetails() {
  customerDetails = swellAPI.getCustomerDetails();
};

var updateCustomerPoints = function updateCustomerPoints() {
  $dom.pointsBalance.html(customerDetails.pointsBalance);
};

var localizePointInfoCards = function localizePointInfoCards() {
  var newVals = [];

  $('[data-redemption-card-points]').each(function (index) {
    var element = $(this);

    SwellMVMT.getPointsFormattedAsCurrency($(this).attr('data-redemption-card-points'), function (amount) {
      newVals.push(amount);
    });
    $(this).html(newVals[index]);
  });
};

var toggleCompletedSwellActions = function toggleCompletedSwellActions() {
  var activeCampaigns = swellAPI.getActiveCampaigns();

  activeCampaigns.forEach(function (campaign) {
    if (campaign.customerCanParticipate == false) {
      var targetID = campaign.id;
      // Update Special campaign ID's

      switch (campaign.id) {
        case 292347:
          // Refer A Friend
          targetID = 'refer-a-friend';
          break;
        case 422035:
          // TODO: Complete Profile
          targetID = 'complete-profile';
          break;
        case 421895:
          // Join Newsletter
          targetID = 'join-newsletter';
          break;
        case 421868:
          // Youtube Follow
          targetID = 'youtube-follow';
          break;
      }

      $('[data-campaign-id="' + targetID + '"]').addClass('is-complete');

      if (targetID == 'youtube-follow') {
        $('[data-campaign-id="' + targetID + '"]').removeAttr('href');
      }
    }
    if (campaign.id == 421868 && !campaign.customerCanParticipate) {
      $('[data-campaign-id="youtube-follow"]').removeAttr('href');
    }
    if (campaign.id == 292347 && !campaign.customerCanParticipate) {
      $('[data-campaign-id="join-newsletter"]').removeAttr('href');
    }
  });
};

var bindUIActions = function bindUIActions() {
  $dom.insiderCardYoutube.on('click', function () {
    var customer_email = customerDetails.email || '';
    var postData = {
      type: 'CustomAction',
      customer_email: customer_email,
      action_name: 'youtube_follow',
      merchant_id: 31462,
      api_key: '8Dj0k1vtz4MCx9SAGgvtYAtt'
    };

    $.post('https://app.swellrewards.com/api/v2/actions', postData, function (data) {}).done(function (jqXHR, textStatus, errorThrow) {
      // console.log('textStatus =', textStatus);
      updateCustomerPoints();
    });
  });

  if ($('.customer-logged-in').length) {
    $dom.insiderCardNewsletter.on('click', function () {
      // Open Email Slideup element and focus on input
      EmailSignup.showEmailSlideUp();
      $('.email-signup--form-input').focus();

      // Bind event to fire Post Request to Swell
      if (newsletterBindingExists == false) {
        $('#email_signup_footer_only_email').on('submit', function () {
          var customer_email = customerDetails.email || '';
          var postData = {
            type: 'CustomAction',
            customer_email: customer_email,
            action_name: 'join_newsletter',
            merchant_id: 31462,
            api_key: '8Dj0k1vtz4MCx9SAGgvtYAtt'
          };

          $.post('https://app.swellrewards.com/api/v2/actions', postData, function (data) {}).done(function (jqXHR, textStatus, errorThrow) {
            if (textStatus == 'success') {
              $('[data-campaign-id="join-newsletter"]').addClass('is-complete');
            }
            updateCustomerPoints();
          });
        });
        newsletterBindingExists = true;
      }
    });
  }
  $dom.insiderLandingCTA.on('click', function () {
    Cookies.set('login_insider_redirect', true);
  });
};

/**
 * @desc wait until Swell is ready to run the fn
 * @param {Function} fn
 * @return {Function}
 */
var waitForSwell = function waitForSwell(fn) {
  return function () {
    if (window.Swell !== undefined) {
      fn();
    } else {
      $(document).on('swell:setup', fn);
    }
  };
};

SwellRewardsMVMTInsider.init = waitForSwell(function () {
  getCustomerDetails();
  cacheDom();
  updateCustomerPoints();
  bindUIActions();
  toggleCompletedSwellActions();
  setTimeout(function () {
    localizePointInfoCards();
  }, 500);
});

window.SwellRewardsMVMTInsider = SwellRewardsMVMTInsider;
exports.default = SwellRewardsMVMTInsider;